import { FontAwesomeIconContainer } from "../../../Components/Icon/FontAwesomeIcon/FontAwesomeIconContainer";

const FontAwesome = () => {
  return <FontAwesomeIconContainer />;
};

export default FontAwesome;
